/**
 * 应用相关常量
 * 包含应用信息、URL、下载链接等
 */

// 应用基本信息
export const APP_NAME = '松鼠藏藏';
export const APP_DESCRIPTION = '让你的小红书关注和收藏井井有条';
export const APP_TAGLINE = '打理小红书的正确姿势';

// 网站 URL
export const WEBSITE_URL = 'https://cangcang.app';
export const LANDING_PAGE_URL = 'https://cangcang.app';

// API URLs
export const PROD_API_URL = 'https://squirrel-collector-api.onrender.com/api';
export const DEV_API_URL = 'http://localhost:3000/api';

// Chrome Extension links
export const CHROME_EXTENSION_URL = 'https://chromewebstore.google.com/detail/%E6%9D%BE%E9%BC%A0%E5%89%AA%E8%97%8F%E5%8A%A9%E6%89%8B/jmhapdkkipfgffgamcinkakdeapnmnem'; // TODO: Update after publishing


// Download links
export const DOWNLOAD_LINKS = {
  windows: 'https://github.com/r9thealien-dev/cangcang-app-releases/releases/download/latest-beta/cangcang-clipper-1.5.0.exe',
  mac: 'https://github.com/r9thealien-dev/cangcang-app-releases/releases/download/latest-beta/cangcang-clipper-1.5.0-arm64.dmg',
} as const;

